module.exports = "/fonts/fa-solid-900.ttf?b6a14bb88dbc580e45034af297c8f605";